import LEASING_COMPANY_INITIAL_STATE from './leasing-company.initial-state';
import LEASING_COMPANY_MUTATIONS from './leasing-company.mutations';
import LEASING_COMPANY_GETTERS from './leasing-company.getters';
import LEASING_COMPANY_ACTIONS from './leasing-company.actions';

// ============================================================================
// :: LEASING COMPANY MODULE STORE
// ============================================================================

const leasingCompanyStore = {
  name: 'leasing-company',
  namespaced: true,
  state: LEASING_COMPANY_INITIAL_STATE(),
  mutations: LEASING_COMPANY_MUTATIONS,
  actions: LEASING_COMPANY_ACTIONS,
  getters: LEASING_COMPANY_GETTERS,
};

export {
  leasingCompanyStore,
};
